import tree from "../../../../components/tree.vue"
import iColumn from "../../../../components/Column.vue";
import iTable from "../../../../components/Table.vue";
import IPagination from "../../../../components/pagination.vue";
import moment from "moment";
// import { emailRule } from '@/utility/index.js'

export default {
  name: "ShiftSetting",
  components: { tree, iColumn, iTable, IPagination },
  data() {
    return {
      formInline: {
        shiftName: ''
      },
      // dialogVisible: false,
      height: '550',
      list: [],
      option: {
        stripe: true,
        border: true,
        loading: false,
        highlightCurrentRow: false,
        mutiSelect: true,
        serialNumber: true,
      },
      columns: [
        {
          prop: "shiftName",
          label: this.$t('ShiftSchedule.shiftName'),
          align: "center",
          // width: "200px"
        },
        {
          prop: "timeDescription",
          label: this.$t('ShiftSchedule.shiftTime'),
          align: "center",
          // width: "200px"
        },
        {
          prop: "createUser",
          label: this.$t('ShiftSchedule.creator'),
          align: "center",
          // width: "200px"
        },
        {
          prop: "createTime",
          label: this.$t('common.setUpTime'),
          align: "center",
          // width: "200",
        }
      ],
      operates: {
        width: 120,
        fixed: "right",
        list: [
           {
              id: '1',
              show: true,
              icon: 'el-icon-edit-outline',
              plain: true,
              disabled: false,
              isBtn: "REPAIRFORM_DETAIL",
              method: (index, row) => {
                this.id = row.id
                this.dialogFormVisible = true;
                this.diaTitle = this.$t('common.btn.edit')
                this.btnType = 'edit'
                this.isDisabled = false
                this.$nextTick(() => {
                  this.$refs.form.clearValidate()
                  this.form.shiftName = row.shiftName
                  this.form.shiftType = row.shiftType
                  if(this.form.shiftType == 1) {
                    this.isShow = true
                    this.isTime = false
                    this.isDisplay = false
                    let [startTime1, endTime1] = row.timeDescription.split('-');
                    this.form.startTime1 = startTime1
                    this.form.endTime1 = endTime1
                    let [startHour1, startMin1] = this.form.startTime1.split(':').map(Number);
                    let [endHour1, endMin1] = this.form.endTime1.split(':').map(Number);
                    this.hour = Math.floor(endHour1-startHour1)
                    this.min = Math.floor(endMin1-startMin1)
                  }else if(this.form.shiftType == 2) {
                    this.isShow = true
                    this.isTime = true
                    this.isDisplay = false
                    let [Time1, Time2] = row.timeDescription.split(' ');
                    console.log(Time1, Time2)
                    let [startTime1, endTime1] = Time1.split('-');
                    this.form.startTime1 = startTime1
                    this.form.endTime1 = endTime1
                    let [startTime2, endTime2] = Time2.split('-');
                    this.form.startTime2 = startTime2
                    this.form.endTime2 = endTime2
                    let [startHour1, startMin1] = this.form.startTime1.split(':').map(Number);
                    let [endHour1, endMin1] = this.form.endTime1.split(':').map(Number);
                    let [startHour2, startMin2] = this.form.startTime2.split(':').map(Number);
                    let [endHour2, endMin2] = this.form.endTime2.split(':').map(Number);
                    this.hour = Math.floor(endHour1-startHour1) + Math.floor(endHour2-startHour2)
                    this.min = Math.floor(endMin1-startMin1) + Math.floor(endMin2-startMin2)
                  }else {
                    this.isShow = true
                    this.isTime = true
                    this.isDisplay = true
                    let [Time1, Time2, Time3] = row.timeDescription.split(' ');
                    let [startTime1, endTime1] = Time1.split('-');
                    this.form.startTime1 = startTime1
                    this.form.endTime1 = endTime1
                    let [startTime2, endTime2] = Time2.split('-');
                    this.form.startTime2 = startTime2
                    this.form.endTime2 = endTime2
                    let [startTime3, endTime3] = Time3.split('-');
                    this.form.startTime3 = startTime3
                    this.form.endTime3 = endTime3
                    let [startHour1, startMin1] = this.form.startTime1.split(':').map(Number);
                    let [endHour1, endMin1] = this.form.endTime1.split(':').map(Number);
                    let [startHour2, startMin2] = this.form.startTime2.split(':').map(Number);
                    let [endHour2, endMin2] = this.form.endTime2.split(':').map(Number);
                    let [startHour3, startMin3] = this.form.startTime3.split(':').map(Number);
                    let [endHour3, endMin3] = this.form.endTime3.split(':').map(Number);
                    this.hour = Math.floor(endHour1-startHour1) + Math.floor(endHour2-startHour2) + Math.floor(endHour3-startHour3)
                    this.min = Math.floor(endMin1-startMin1) + Math.floor(endMin2-startMin2) + Math.floor(endMin3-startMin3)
                  }
                })
              }
          },
          {
              id: '2',
              show: true,
              icon: 'el-icon-delete',
              plain: true,
              disabled: false,
              isBtn: "REPAIRFORM_DETAIL",
              method: (index, row) => {
                console.log(row)
                this.id = row.id
                this.deleteShift()
                  // this.requestSerialNumber = row.requestSerialNumber
                  // this.deleteRepair()
              }
          },
          {
              id: '3',
              show: true,
              icon: 'iconfont iconicon-chakanxq',
              plain: true,
              disabled: false,
              isBtn: "REPAIRFORM_DETAIL",
              method: (index, row) => {
                this.id = row.id
                this.dialogFormVisible = true;
                this.diaTitle = this.$t('common.btn.detail')
                this.btnType = 'detail'
                this.isDisabled = true
                this.$nextTick(() => {
                  this.$refs.form.clearValidate()
                  this.form.shiftName = row.shiftName
                  this.form.shiftType = row.shiftType
                  if(this.form.shiftType == 1) {
                    this.isShow = true
                    this.isTime = false
                    this.isDisplay = false
                    let [startTime1, endTime1] = row.timeDescription.split('-');
                    this.form.startTime1 = startTime1
                    this.form.endTime1 = endTime1
                    let [startHour1, startMin1] = this.form.startTime1.split(':').map(Number);
                    let [endHour1, endMin1] = this.form.endTime1.split(':').map(Number);
                    this.hour = Math.floor(endHour1-startHour1)
                    this.min = Math.floor(endMin1-startMin1)
                  }else if(this.form.shiftType == 2) {
                    this.isShow = true
                    this.isTime = true
                    this.isDisplay = false
                    let [Time1, Time2] = row.timeDescription.split(' ');
                    console.log(Time1, Time2)
                    let [startTime1, endTime1] = Time1.split('-');
                    this.form.startTime1 = startTime1
                    this.form.endTime1 = endTime1
                    let [startTime2, endTime2] = Time2.split('-');
                    this.form.startTime2 = startTime2
                    this.form.endTime2 = endTime2
                    let [startHour1, startMin1] = this.form.startTime1.split(':').map(Number);
                    let [endHour1, endMin1] = this.form.endTime1.split(':').map(Number);
                    let [startHour2, startMin2] = this.form.startTime2.split(':').map(Number);
                    let [endHour2, endMin2] = this.form.endTime2.split(':').map(Number);
                    this.hour = Math.floor(endHour1-startHour1) + Math.floor(endHour2-startHour2)
                    this.min = Math.floor(endMin1-startMin1) + Math.floor(endMin2-startMin2)
                  }else {
                    this.isShow = true
                    this.isTime = true
                    this.isDisplay = true
                    let [Time1, Time2, Time3] = row.timeDescription.split(' ');
                    let [startTime1, endTime1] = Time1.split('-');
                    this.form.startTime1 = startTime1
                    this.form.endTime1 = endTime1
                    let [startTime2, endTime2] = Time2.split('-');
                    this.form.startTime2 = startTime2
                    this.form.endTime2 = endTime2
                    let [startTime3, endTime3] = Time3.split('-');
                    this.form.startTime3 = startTime3
                    this.form.endTime3 = endTime3
                    let [startHour1, startMin1] = this.form.startTime1.split(':').map(Number);
                    let [endHour1, endMin1] = this.form.endTime1.split(':').map(Number);
                    let [startHour2, startMin2] = this.form.startTime2.split(':').map(Number);
                    let [endHour2, endMin2] = this.form.endTime2.split(':').map(Number);
                    let [startHour3, startMin3] = this.form.startTime3.split(':').map(Number);
                    let [endHour3, endMin3] = this.form.endTime3.split(':').map(Number);
                    this.hour = Math.floor(endHour1-startHour1) + Math.floor(endHour2-startHour2) + Math.floor(endHour3-startHour3)
                    this.min = Math.floor(endMin1-startMin1) + Math.floor(endMin2-startMin2) + Math.floor(endMin3-startMin3)
                  }
                })
              }
          }
        ],
      },
      currentPage: 1,
      pageSize: 10,
      total: 1,
      dialogFormVisible: false,
      formLabelWidth: '100px',
      diaTitle: '',
      btnType: '',
      rules: {
        shiftName: [
          { required: true, message: this.$t('ShiftSchedule.PleaseEnterShiftName'), trigger: 'blur' },
        ],
        shiftType: [
          { required: true, message: this.$t('ShiftSchedule.PleaseSelectNumberCommuteTimes'), trigger: 'change' }
        ],
        startTime1: [
          { required: true, message: this.$t('ShiftSchedule.PleaseSelectFirstWorkTime'), trigger: 'change' }
        ],
        startTime2: [
          { required: true, message: this.$t('ShiftSchedule.PleaseSelectSecondWorkTime'), trigger: 'change' }
        ],
        startTime3: [
          { required: true, message: this.$t('ShiftSchedule.PleaseSelectThirdWorkTime'), trigger: 'change' }
        ]
      },
      form: {
        shiftName: '',
        shiftType: '1',
        // time1: [],
        // time2: [],
        // time3: [],
        startTime1: '08:00',
        endTime1: '12:00',
        startTime2: '',
        endTime2: '',
        startTime3: '',
        endTime3: '',
        timeContent: ''
      },
      isShow: true,
      isTime: false,
      isDisplay: false,
      // RoleList: [],
      // dialogPowerVisible: false,
      // data: [],
      // defaultProps: {
      //   children: 'children',
      //   label: 'value',
      // },
      // keyList: [],
      // filterText: '',
      selected: [],
      id: '',
      hour: '4',
      min: '0',
      isDisabled: false
      // rolePower: '',
      // companyId: '',
      // diaHidden: false,

      // isShow: true,
      // isTrue: false,
    };
  },
  // watch: {
  //   filterText(val) {
  //     this.$refs.tree.filter(val);
  //   }
  // },
  // created() {
  //   this.getRole()

  //   if (sessionStorage.getItem("userType") == 0) {
  //     this.isShow = true
  //   } else {
  //     this.isShow = false
  //   }
  // },
  mounted() {
    // console.log(this.$route.params)
    // if (this.$route.params) {
    //   this.id = this.$route.params.id
    //   this.name = this.$route.params.name
    // }
    this.getShiftList()
  },
  methods: {
    getShiftList() {
      let param = {
        companyId: sessionStorage.getItem("companyId"),
        shiftName: this.formInline.shiftName,
        pageNum: this.currentPage,
        pageSize: this.pageSize
      }
      this.$store.dispatch('ShiftSchedule/GET_SELECTSHIFTLIST', param).then(res => {
        if (res) {
          if (res.data.code == 200) {
            this.list = res.data.data.list
            this.$refs.page.CommandTotal = res.data.data.total
          }
        }
      })
    },
    onSearch() {
      this.currentPage = 1
      this.getShiftList()
    },
    onClear() {
      this.formInline = {
        shiftName: '',
      }
      this.getShiftList()
    },
    handleSelectionChange(val) {
      this.selected = val
      this.id = this.selected[0].id
    },
    changeSize(item) {
      this.pageSize = item.pageSize
      this.currentPage = item.pageNum
      this.getShiftList();
    },
    addShift() {
      this.dialogFormVisible = true;
      this.diaTitle = this.$t('common.btn.add')
      this.btnType = 'add'
      this.isDisabled = false
      // this.keyList = []
      this.$nextTick(() => {
        this.$refs.form.resetFields()
        this.isShow = true
        this.isTime = false
        this.isDisplay = false
        this.form.startTime1 = '08:00'
        this.form.endTime1 = '12:00'
        let [startHour1, startMin1] = this.form.startTime1.split(':').map(Number);
        let [endHour1, endMin1] = this.form.endTime1.split(':').map(Number);
        this.hour = Math.floor(endHour1-startHour1)
        this.min = Math.floor(endMin1-startMin1)
      })
    },
    editShift() {
      this.dialogFormVisible = true;
      this.diaTitle = this.$t('common.btn.edit')
      this.btnType = 'edit'
      this.isDisabled = false
      this.$nextTick(() => {
        this.$refs.form.clearValidate()
        this.id = this.selected[0].id
        this.form.shiftName = this.selected[0].shiftName
        this.form.shiftType = this.selected[0].shiftType
        if(this.form.shiftType == 1) {
          this.isShow = true
          this.isTime = false
          this.isDisplay = false
          let [startTime1, endTime1] = this.selected[0].timeDescription.split('-');
          this.form.startTime1 = startTime1
          this.form.endTime1 = endTime1
          let [startHour1, startMin1] = this.form.startTime1.split(':').map(Number);
          let [endHour1, endMin1] = this.form.endTime1.split(':').map(Number);
          this.hour = Math.floor(endHour1-startHour1)
          this.min = Math.floor(endMin1-startMin1)
        }else if(this.form.shiftType == 2) {
          this.isShow = true
          this.isTime = true
          this.isDisplay = false
          let [Time1, Time2] = this.selected[0].timeDescription.split(' ');
          console.log(Time1, Time2)
          let [startTime1, endTime1] = Time1.split('-');
          this.form.startTime1 = startTime1
          this.form.endTime1 = endTime1
          let [startTime2, endTime2] = Time2.split('-');
          this.form.startTime2 = startTime2
          this.form.endTime2 = endTime2
          let [startHour1, startMin1] = this.form.startTime1.split(':').map(Number);
          let [endHour1, endMin1] = this.form.endTime1.split(':').map(Number);
          let [startHour2, startMin2] = this.form.startTime2.split(':').map(Number);
          let [endHour2, endMin2] = this.form.endTime2.split(':').map(Number);
          this.hour = Math.floor(endHour1-startHour1) + Math.floor(endHour2-startHour2)
          this.min = Math.floor(endMin1-startMin1) + Math.floor(endMin2-startMin2)
        }else {
          this.isShow = true
          this.isTime = true
          this.isDisplay = true
          let [Time1, Time2, Time3] = this.selected[0].timeDescription.split(' ');
          let [startTime1, endTime1] = Time1.split('-');
          this.form.startTime1 = startTime1
          this.form.endTime1 = endTime1
          let [startTime2, endTime2] = Time2.split('-');
          this.form.startTime2 = startTime2
          this.form.endTime2 = endTime2
          let [startTime3, endTime3] = Time3.split('-');
          this.form.startTime3 = startTime3
          this.form.endTime3 = endTime3
          let [startHour1, startMin1] = this.form.startTime1.split(':').map(Number);
          let [endHour1, endMin1] = this.form.endTime1.split(':').map(Number);
          let [startHour2, startMin2] = this.form.startTime2.split(':').map(Number);
          let [endHour2, endMin2] = this.form.endTime2.split(':').map(Number);
          let [startHour3, startMin3] = this.form.startTime3.split(':').map(Number);
          let [endHour3, endMin3] = this.form.endTime3.split(':').map(Number);
          this.hour = Math.floor(endHour1-startHour1) + Math.floor(endHour2-startHour2) + Math.floor(endHour3-startHour3)
          this.min = Math.floor(endMin1-startMin1) + Math.floor(endMin2-startMin2) + Math.floor(endMin3-startMin3)
        }
      })


    },
    changeType(e) {
      if(e == 1) {
        this.isShow = true
        this.isTime = false
        this.isDisplay = false
        this.form.startTime1 = '08:00'
        this.form.endTime1 = '12:00'
        let [startHour1, startMin1] = this.form.startTime1.split(':').map(Number);
        let [endHour1, endMin1] = this.form.endTime1.split(':').map(Number);
        this.hour = Math.floor(endHour1-startHour1)
        this.min = Math.floor(endMin1-startMin1)
      }else if(e == 2) {
        this.isShow = true
        this.isTime = true
        this.isDisplay = false
        this.form.startTime1 = '08:00'
        this.form.endTime1 = '12:00'
        this.form.startTime2 = '13:00'
        this.form.endTime2 = '18:00'
        let [startHour1, startMin1] = this.form.startTime1.split(':').map(Number);
        let [endHour1, endMin1] = this.form.endTime1.split(':').map(Number);
        let [startHour2, startMin2] = this.form.startTime2.split(':').map(Number);
        let [endHour2, endMin2] = this.form.endTime2.split(':').map(Number);
        this.hour = Math.floor(endHour1-startHour1) + Math.floor(endHour2-startHour2)
        this.min = Math.floor(endMin1-startMin1) + Math.floor(endMin2-startMin2)
      }else {
        this.isShow = true
        this.isTime = true
        this.isDisplay = true
        this.form.startTime1 = '08:00'
        this.form.endTime1 = '11:00'
        this.form.startTime2 = '12:00'
        this.form.endTime2 = '15:00'
        this.form.startTime3 = '16:00'
        this.form.endTime3 = '20:00'
        let [startHour1, startMin1] = this.form.startTime1.split(':').map(Number);
        let [endHour1, endMin1] = this.form.endTime1.split(':').map(Number);
        let [startHour2, startMin2] = this.form.startTime2.split(':').map(Number);
        let [endHour2, endMin2] = this.form.endTime2.split(':').map(Number);
        let [startHour3, startMin3] = this.form.startTime3.split(':').map(Number);
        let [endHour3, endMin3] = this.form.endTime3.split(':').map(Number);
        this.hour = Math.floor(endHour1-startHour1) + Math.floor(endHour2-startHour2) + Math.floor(endHour3-startHour3)
        this.min = Math.floor(endMin1-startMin1) + Math.floor(endMin2-startMin2) + Math.floor(endMin3-startMin3)
      }
    },
    changeStartOne(e) {
      let [hour, min] = e.split(':').map(Number);
      console.log(hour, min)
    },
    changeEndOne(e) {
      console.log(e)
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this.form)
          let timeContent = [
            {
              commuteType:1,
              startTime: this.form.startTime1,
              endTime: this.form.endTime1
            },
            {
              commuteType:2,
              startTime: this.form.startTime2,
              endTime: this.form.endTime2
            },
            {
              commuteType:3,
              startTime: this.form.startTime3,
              endTime: this.form.endTime3
            }
          ]
          let param = {
            companyId: sessionStorage.getItem("companyId"),
            shiftName: this.form.shiftName,
            shiftType: this.form.shiftType,
            timeContent: JSON.stringify(timeContent),
          }
          
          if (this.btnType == 'add') {
            this.$store.dispatch('ShiftSchedule/GET_INSERTSHIFT', param).then(res => {
              if (res.data.code == 200) {
                this.$message.success({
                  message: res.data.data,
                  duration: 6000,
                })
                this.dialogFormVisible = false;
                this.getShiftList();
                this.closeDia();
              } else {
                this.$message.error(res.data.msg)
              }

            }).catch(err => { })
          } else {
            param.id = this.id
            this.$store.dispatch('ShiftSchedule/GET_UPDATESHIFT', param).then(res => {
              if (res.data.code == 200) {
                // this.$message.success(this.$t('PlatformSettings.form.editUserSuccess'))
                this.$message.success({
                  message: res.data.data,
                  duration: 6000,
                })
                this.dialogFormVisible = false;
                this.getShiftList();
                this.closeDia();
              } else {
                this.$message.error(res.data.msg)
              }

            }).catch(err => { })
          }
        } else {
          return false;
        }
      });
    },
    cancle(formName) {
      this.dialogFormVisible = false;
      this.form = {
        shiftName: '',
        shiftType: '1',
        startTime1: '',
        endTime1: '',
        startTime2: '',
        endTime2: '',
        startTime3: '',
        endTime3: '',
        timeContent: ''
      }
    },
    closeDia() {
      this.form = {
        shiftName: '',
        shiftType: '1',
        startTime1: '',
        endTime1: '',
        startTime2: '',
        endTime2: '',
        startTime3: '',
        endTime3: '',
        timeContent: ''
      }
      this.dialogFormVisible = false;
    },
    // getRole() {
    //   this.$store.dispatch('roleManagement/GET_QUERY', {}).then(res => {
    //     if (res) {
    //       if (res.data.code == 200) {
    //         this.RoleList = res.data.data
    //       }
    //     }
    //   })
    // },
    // filterNode(value, data) {
    //   if (!value) return true;
    //   return data.value.indexOf(value) !== -1;
    // },
    // getTree() {
    //   let param = {
    //     orgId: sessionStorage.getItem("roleData"),
    //     companyId: sessionStorage.getItem("companyId"),
    //   }
    //   this.$store.dispatch('tree/GET_QUERYTREE', param).then(res => {
    //     if (res) {
    //       if (res.data.code == 200) {
    //         this.data = res.data.data
    //       }
    //     }
    //   })
    // },
    // getPower() {
    //   this.dialogPowerVisible = true
    //   this.diaHidden = true
    //   this.getTree()
    //   this.$nextTick(() => {
    //   })
    // },
    // submit(formName) {
    //   this.$refs[formName].validate((valid) => {
    //     if (valid) {
    //       this.form.roleData = this.$refs.tree.getCheckedKeys().join(',')
    //       console.log(this.form.roleData)
    //       this.dialogPowerVisible = false
    //       this.diaHidden = true
    //     } else {
    //       return false;
    //     }
    //   });
    // },
    // handCheck(currentNode, treeStatus) {
    // },
    // checkChange(val, checked) {
    // },
    // handleClose() {
    //   this.dialogPowerVisible = false
    //   this.diaHidden = false
    // },
    deleteShift() {
      this.$confirm(this.$t('common.btn.confirmDelete'), this.$t('common.btn.hint'),
        {
          cancelButtonText: this.$t('common.btn.cancel'),
          confirmButtonText: this.$t('common.btn.confirm'),
          type: 'warning'
        }).then(res => {
          let param = { id: this.id }
          this.$store.dispatch('ShiftSchedule/GET_DELETESHIFT', param).then(response => {
            if (response.data.code == 200) {
              this.getShiftList()
              this.$message.success(this.$t('common.btn.deleteSuccess'))
            } else {
              this.$message.error(response.data.msg)
            }
          }).catch(error => { })
        }).catch(err => {
        })
    },
    queryDDetail() {
      // let param = {
      //   id: this.id,
      // }
      // this.$store.dispatch('ShiftSchedule/GET_SELECTSHIFT', param).then(res => {
      //   if (res) {
      //     if (res.data.code == 200) {
      //       this.form = res.data.data
      //       this.$nextTick(() => {
      //             this.$refs.form.clearValidate()
      //             // this.form.shiftName = row.shiftName
      //             // this.form.shiftType = row.shiftType
      //             if(this.form.shiftType == 1) {
      //               this.isShow = true
      //               this.isTime = false
      //               this.isDisplay = false
      //               let [startTime1, endTime1] = row.timeDescription.split('-');
      //               this.form.startTime1 = startTime1
      //               this.form.endTime1 = endTime1
      //               let [startHour1, startMin1] = this.form.startTime1.split(':').map(Number);
      //               let [endHour1, endMin1] = this.form.endTime1.split(':').map(Number);
      //               this.hour = Math.floor(endHour1-startHour1)
      //               this.min = Math.floor(endMin1-startMin1)
      //             }else if(this.form.shiftType == 2) {
      //               this.isShow = true
      //               this.isTime = true
      //               this.isDisplay = false
      //               let [Time1, Time2] = row.timeDescription.split(' ');
      //               console.log(Time1, Time2)
      //               let [startTime1, endTime1] = Time1.split('-');
      //               this.form.startTime1 = startTime1
      //               this.form.endTime1 = endTime1
      //               let [startTime2, endTime2] = Time2.split('-');
      //               this.form.startTime2 = startTime2
      //               this.form.endTime2 = endTime2
      //               let [startHour1, startMin1] = this.form.startTime1.split(':').map(Number);
      //               let [endHour1, endMin1] = this.form.endTime1.split(':').map(Number);
      //               let [startHour2, startMin2] = this.form.startTime2.split(':').map(Number);
      //               let [endHour2, endMin2] = this.form.endTime2.split(':').map(Number);
      //               this.hour = Math.floor(endHour1-startHour1) + Math.floor(endHour2-startHour2)
      //               this.min = Math.floor(endMin1-startMin1) + Math.floor(endMin2-startMin2)
      //             }else {
      //               this.isShow = true
      //               this.isTime = true
      //               this.isDisplay = true
      //               let [Time1, Time2, Time3] = row.timeDescription.split(' ');
      //               let [startTime1, endTime1] = Time1.split('-');
      //               this.form.startTime1 = startTime1
      //               this.form.endTime1 = endTime1
      //               let [startTime2, endTime2] = Time2.split('-');
      //               this.form.startTime2 = startTime2
      //               this.form.endTime2 = endTime2
      //               let [startTime3, endTime3] = Time3.split('-');
      //               this.form.startTime3 = startTime3
      //               this.form.endTime3 = endTime3
      //               let [startHour1, startMin1] = this.form.startTime1.split(':').map(Number);
      //               let [endHour1, endMin1] = this.form.endTime1.split(':').map(Number);
      //               let [startHour2, startMin2] = this.form.startTime2.split(':').map(Number);
      //               let [endHour2, endMin2] = this.form.endTime2.split(':').map(Number);
      //               let [startHour3, startMin3] = this.form.startTime3.split(':').map(Number);
      //               let [endHour3, endMin3] = this.form.endTime3.split(':').map(Number);
      //               this.hour = Math.floor(endHour1-startHour1) + Math.floor(endHour2-startHour2) + Math.floor(endHour3-startHour3)
      //               this.min = Math.floor(endMin1-startMin1) + Math.floor(endMin2-startMin2) + Math.floor(endMin3-startMin3)
      //             }
      //           })
      //     }
      //   }
      // })
    }

    // changeSort(item) {
    //   this.columns = [];
    //   this.$nextTick(function () {
    //     this.columns = item;
    //   });
    // },

    // ListSetting() {
    //   this.$refs.listSet.dialogVisible = true;
    // },
  },
};
